/* Elibelinde shell.
   window.EB.lock() / EB.unlock(): counter, html.eb-locked
   window.EB.cart.open() / close() / refresh()
   document event eb:cart:updated { detail: { open: true } }
   Cart count: [data-eb-cart-count]
   Open the drawer: [data-eb-cart-open]
   Header height: --eb-header-h on <html>
   Cart section id in templates/cart.json must stay "eb-cart". */
(function () {
  'use strict';

  var locks = 0;
  var cartReturn = null;
  var menuReturn = null;
  var busy = false;
  var wide = window.innerWidth >= 1100;

  function lock() {
    locks += 1;
    document.documentElement.classList.add('eb-locked');
  }

  function unlock() {
    locks = Math.max(0, locks - 1);
    if (locks === 0) document.documentElement.classList.remove('eb-locked');
  }

  function releaseAll() {
    locks = 0;
    document.documentElement.classList.remove('eb-locked');
  }

  function drawer() {
    return document.querySelector('[data-eb-cart-drawer]');
  }

  function menu() {
    return document.querySelector('[data-eb-menu]');
  }

  function menuToggle() {
    return document.querySelector('[data-eb-menu-toggle]');
  }

  function menuIsOpen() {
    var el = menu();
    return !!(el && !el.hasAttribute('hidden'));
  }

  function cartIsOpen() {
    var el = drawer();
    return !!(el && el.classList.contains('is-open'));
  }

  function setCount(count) {
    var n = parseInt(count, 10);
    if (isNaN(n) || n < 0) n = 0;
    var nodes = document.querySelectorAll('[data-eb-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = String(n);
      if (n > 0) nodes[i].removeAttribute('hidden');
      else nodes[i].setAttribute('hidden', '');
    }
  }

  function replaceLines(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-eb-cart-lines]');
    if (!fresh) return false;
    var targets = document.querySelectorAll('[data-eb-cart-lines]');
    if (!targets.length) return false;
    for (var i = 0; i < targets.length; i++) {
      targets[i].replaceWith(fresh.cloneNode(true));
    }
    if (fresh.hasAttribute('data-count')) setCount(fresh.getAttribute('data-count'));
    return true;
  }

  function endpoint(name, fallback) {
    var el = drawer();
    var value = el ? el.getAttribute(name) : '';
    return value || fallback;
  }

  function refresh() {
    var countReq = fetch(endpoint('data-eb-cart-js', '/cart.js'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});

    var htmlReq = fetch(endpoint('data-eb-cart-section', '/cart?sections=eb-cart'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data && data['eb-cart']) replaceLines(data['eb-cart']);
      })
      .catch(function () {});

    return Promise.all([countReq, htmlReq]);
  }

  function openCart() {
    var el = drawer();
    if (!el) {
      window.location.href = '/cart';
      return;
    }
    if (!cartIsOpen()) {
      cartReturn = document.activeElement;
      el.classList.add('is-open');
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
      lock();
    }
    var closeBtn = el.querySelector('[data-eb-cart-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeCart() {
    var el = drawer();
    if (!cartIsOpen()) return;
    el.classList.remove('is-open');
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
    unlock();
    if (cartReturn && typeof cartReturn.focus === 'function') cartReturn.focus();
  }

  function setMenuExpanded(open) {
    var toggle = menuToggle();
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var label = open ? toggle.getAttribute('data-label-close') : toggle.getAttribute('data-label-open');
    if (label) toggle.setAttribute('aria-label', label);
  }

  function openMenu() {
    var el = menu();
    if (!el || menuIsOpen()) return;
    menuReturn = document.activeElement;
    el.removeAttribute('hidden');
    setMenuExpanded(true);
    lock();
    var closeBtn = el.querySelector('[data-eb-menu-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeMenu() {
    var el = menu();
    if (!menuIsOpen()) return;
    el.setAttribute('hidden', '');
    setMenuExpanded(false);
    unlock();
    if (menuReturn && typeof menuReturn.focus === 'function') menuReturn.focus();
  }

  function changeLine(key, qty) {
    if (busy || !key) return;
    busy = true;
    var el = drawer();
    if (el) el.setAttribute('aria-busy', 'true');
    fetch(endpoint('data-eb-cart-change', '/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .catch(function () {})
      .then(function () { return refresh(); })
      .then(function () {
        busy = false;
        if (el) el.removeAttribute('aria-busy');
      });
  }

  function lineQty(button) {
    var key = button.getAttribute('data-key');
    var root = button.closest('[data-eb-cart-lines]');
    var current = 0;
    if (root) {
      var inputs = root.querySelectorAll('[data-eb-qty-input]');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].getAttribute('data-key') === key) {
          current = parseInt(inputs[i].value, 10) || 0;
          break;
        }
      }
    }
    var action = button.getAttribute('data-eb-qty');
    var next = current;
    if (action === 'inc') next = current + 1;
    if (action === 'dec') next = Math.max(0, current - 1);
    if (action === 'remove') next = 0;
    changeLine(key, next);
  }

  function focusable(container) {
    if (!container) return [];
    var nodes = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
    var list = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getClientRects().length) list.push(nodes[i]);
    }
    return list;
  }

  function trap(container, event) {
    var list = focusable(container);
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function headerShell() {
    var header = document.querySelector('[data-eb-header]');
    if (!header) return null;
    return header.closest('.eb-header-section') || header;
  }

  function setHeaderH() {
    var shell = headerShell();
    if (!shell) return;
    document.documentElement.style.setProperty('--eb-header-h', shell.offsetHeight + 'px');
  }

  function syncHeader() {
    setHeaderH();
  }

  window.EB = {
    lock: lock,
    unlock: unlock,
    cart: {
      open: openCart,
      close: closeCart,
      refresh: refresh
    }
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-eb-cart-open]');
    if (opener) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      if (drawer()) {
        event.preventDefault();
        openCart();
      }
      return;
    }
    if (event.target.closest('[data-eb-cart-close], [data-eb-cart-backdrop]')) {
      closeCart();
      return;
    }
    if (event.target.closest('[data-eb-menu-toggle]')) {
      if (menuIsOpen()) closeMenu();
      else openMenu();
      return;
    }
    if (event.target.closest('[data-eb-menu-close]')) {
      closeMenu();
      return;
    }
    var qtyBtn = event.target.closest('[data-eb-qty]');
    if (qtyBtn) lineQty(qtyBtn);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-eb-qty-input]');
    if (!input) return;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;
    changeLine(input.getAttribute('data-key'), qty);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      if (cartIsOpen()) {
        event.preventDefault();
        closeCart();
        return;
      }
      if (menuIsOpen()) {
        event.preventDefault();
        closeMenu();
      }
      return;
    }
    if (event.key !== 'Tab') return;
    if (cartIsOpen()) {
      var panel = drawer() && drawer().querySelector('.eb-drawer__panel');
      trap(panel, event);
    } else if (menuIsOpen()) {
      trap(menu(), event);
    }
  });

  document.addEventListener('eb:cart:updated', function (event) {
    var shouldOpen = !!(event.detail && event.detail.open);
    if (shouldOpen && !drawer()) {
      window.location.href = '/cart';
      return;
    }
    refresh().then(function () {
      if (shouldOpen) openCart();
    });
  });

  window.addEventListener('resize', function () {
    var now = window.innerWidth >= 1100;
    if (now && !wide) {
      closeMenu();
      releaseAll();
    }
    wide = now;
    syncHeader();
  });
  window.addEventListener('pagehide', releaseAll);

  function activatePress(row) {
    var root = row.closest('[data-eb-press]');
    if (!root) return;
    var id = row.getAttribute('data-eb-press-row');
    var rows = root.querySelectorAll('[data-eb-press-row]');
    var photos = root.querySelectorAll('[data-eb-press-photo]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.toggle('is-active', rows[i].getAttribute('data-eb-press-row') === id);
    }
    for (var j = 0; j < photos.length; j++) {
      var on = photos[j].getAttribute('data-eb-press-photo') === id;
      photos[j].classList.toggle('is-active', on);
      if (on) photos[j].removeAttribute('aria-hidden');
      else photos[j].setAttribute('aria-hidden', 'true');
    }
  }

  document.addEventListener('mouseover', function (event) {
    var row = event.target.closest && event.target.closest('[data-eb-press-row]');
    if (row) activatePress(row);
  });

  document.addEventListener('focusin', function (event) {
    var row = event.target.closest && event.target.closest('[data-eb-press-row]');
    if (row) activatePress(row);
  });

  document.addEventListener('click', function (event) {
    var row = event.target.closest && event.target.closest('[data-eb-press-row]');
    if (!row) return;
    var coarse = window.matchMedia('(hover: none)').matches;
    if (!coarse) return;
    if (row.classList.contains('is-active') && row.tagName === 'A') return;
    event.preventDefault();
    activatePress(row);
  });

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(setHeaderH);
  syncHeader();
})();
